import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalService } from '@freelancer/ui';
import { ModalSize } from '@freelancer/ui/modal';
import { LoginOrSignup } from '../../login-signup/login-signup-modal';

@Component({
  selector: 'app-user-profile-logged-out-link',
  template: `
    <fl-link
      *ngIf="username"
      i18n="View users full profile link"
      [flTrackingLabel]="flTrackingLabel"
      (click)="openSignUpModal()"
    >
      View {{ username }}'s full profile
    </fl-link>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileLoggedOutLinkComponent {
  @Input() flTrackingLabel: string;
  @Input() username: string;

  constructor(private modalService: ModalService) {}

  openSignUpModal() {
    this.modalService.open('LoginSignupModal', {
      inputs: {
        form: LoginOrSignup.SIGNUP,
      },
      closeable: true,
      edgeToEdge: true,
      size: ModalSize.XSMALL,
      mobileFullscreen: true,
    });
  }
}
